import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MaintenanceTypeService } from '../services/maintenance-type.service';
import { Router } from '@angular/router';
import { Message} from 'primeng/primeng';

@Component({
  selector: 'app-maintenance-type',
  templateUrl: './maintenance-type.component.html',
  styleUrls: ['./maintenance-type.component.css']
})
export class MaintenanceTypeComponent implements OnInit {
  msgs: Message[] = [];
  maintenanceTypes:any[];
  maintenanceType:any;
  dialog: boolean;
  blocked:boolean=false;
  stateOptions: any[];
  action:String;

  constructor(private router:Router,private maintenanceTypeService:MaintenanceTypeService,private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.stateOptions = [{label: 'Inhabilitado', value: 'I'}, {label: 'Habilitado', value: 'H'}];
    this.init();
  }

  init(){
    this.maintenanceTypeService.findAll().subscribe(response => {
      if(response.status == 'OK'){
        this.maintenanceTypes = [...response.maintenanceTypes];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
    }, error =>{
      console.error(error);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });

    this.hideDialog();
  }

  openNew() {
    this.action="CREATE";
    this.dialog = true;
  }

  hideDialog() {
    this.dialog = false;
    this.maintenanceType = {status:"H"};
  }

  edit(maintenanceType: any) {
    this.action="UPDATE";
    this.maintenanceType = {...maintenanceType};
    this.dialog = true;
  }

  save() {
    this.blocked = true;
    if (this.action == "UPDATE") {
      this.maintenanceTypeService.edit(this.maintenanceType).subscribe(response => {
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'success', summary:'EXITO', detail:"Registro modificado exitosamente"}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blocked = false;
      }, error =>{
        console.error(error);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blocked = false;
      });
    }else {
      this.maintenanceTypeService.create(this.maintenanceType).subscribe(response => {
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'success', summary:'EXITO', detail:"Registro insertado exitosamente"}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blocked = false;
      }, error =>{
        console.error(error);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blocked = false;
      });
    }

  }

  delete(maintenanceType:any) {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar el tipo de manteimiento ' + maintenanceType.name + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.blocked = true;
        this.maintenanceTypeService.remove(maintenanceType).subscribe(response => {
          if(response.status == 'OK'){
            this.init();
            this.msgs = [{severity:'success', summary:'EXITO', detail:"Registro eliminado exitosamente"}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blocked = false;
        }, error =>{
          console.error(error);
          this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
          this.blocked = false;
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/maintenance-type/maintenance-type.component.ts